import React, { Component } from 'react';
import { Box, Typography } from '@material-ui/core';

import { InputSelectNative } from '../../../commonModules/interface/form-input-inline';

/**
 * Zone declaree d'un point de vente : Region puis Province (listes dependantes),
 * selon le referentiel du pays de reference servi par le backend
 * (GET /agent/reference/admin-areas : fiche agent, sinon pays du compte).
 *
 * Props :
 *  - agentId        : fiche existante (le pays de la fiche prime), absent a la creation
 *  - area1, area2   : valeurs courantes (libelles canoniques)
 *  - onChange(a1, a2) : appele a chaque modification ; changer la Region remet la Province a zero
 *  - onLoaded(ref)  : facultatif, recoit la reponse du referentiel
 *
 * Une valeur courante absente du referentiel (ancien decoupage) est affichee
 * "(hors referentiel)" sans etre perdue.
 */
class AdminAreaSelect extends Component {
    state = {
        loading: true,
        error: "",
        reference: null, // {country, available, levels, areas}
    }

    componentDidMount = async () => {
        const { agentId } = this.props;
        try {
            const url = "/agent/reference/admin-areas" + (agentId ? "?agentId=" + encodeURIComponent(agentId) : "");
            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
            });
            // Lecture défensive : un 403 du BFF a un corps vide (response.json() jetterait).
            const text = await response.text();
            let resp = {};
            if (text) {
                try { resp = JSON.parse(text); } catch (e) { resp = { error: text }; }
            }
            if (!response.ok) {
                // domainModel répond 404 « No Access » (pas 403) à un rôle sans droit.
                const noAccess = response.status === 403
                    || (response.status === 404 && /no access/i.test(String(resp.error || "")));
                this.setState({
                    loading: false,
                    error: noAccess ? "Votre rôle ne donne pas accès au référentiel de zones" : (resp.error || "Référentiel de zones indisponible"),
                });
                return;
            }
            this.setState({ loading: false, reference: resp });
            if (this.props.onLoaded) {
                this.props.onLoaded(resp);
            }
        } catch (err) {
            console.log("[ERROR], getting admin areas", err);
            this.setState({ loading: false, error: "Référentiel de zones indisponible" });
        }
    }

    render() {
        const { area1, area2, onChange } = this.props;
        const { loading, error, reference } = this.state;

        if (loading) {
            return <Typography variant="body2" color="textSecondary">Chargement du référentiel de zones…</Typography>;
        }
        if (error) {
            return <Typography variant="body2" color="error">{error}</Typography>;
        }

        const available = !!(reference && reference.available);
        const areas = (available && Array.isArray(reference.areas)) ? reference.areas : [];
        const levels = (reference && Array.isArray(reference.levels)) ? reference.levels : [];
        const label1 = levels[0] || "Région";
        const label2 = levels[1] || "Province";

        if (!available) {
            const pays = reference && reference.country ? " (" + reference.country + ")" : "";
            return (
                <Box p={1}>
                    <Typography variant="body2" color="textSecondary">
                        {"Pas de référentiel de zones pour ce pays" + pays}
                    </Typography>
                </Box>
            );
        }

        const value1 = area1 || "";
        const value2 = area2 || "";
        const current = areas.find(a => a.name === value1);
        const children = current && Array.isArray(current.children) ? current.children : [];

        const opts1 = areas.map(a => <option key={a.name} value={a.name}>{a.name}</option>);
        if (value1 && !current) {
            opts1.push(<option key="__hors1" value={value1}>{value1 + " (hors référentiel)"}</option>);
        }
        const opts2 = children.map(c => <option key={c} value={c}>{c}</option>);
        if (value2 && !children.includes(value2)) {
            opts2.push(<option key="__hors2" value={value2}>{value2 + " (hors référentiel)"}</option>);
        }

        return (
            <div>
                <InputSelectNative
                    name="locationArea1"
                    label={label1}
                    labelWidth={90}
                    value={value1}
                    options={opts1}
                    onChange={e => onChange(e.target.value, "")}
                />
                <InputSelectNative
                    name="locationArea2"
                    label={label2}
                    labelWidth={90}
                    value={value2}
                    disabled={!value1}
                    options={opts2}
                    onChange={e => onChange(value1, e.target.value)}
                />
            </div>
        );
    }
}

export default AdminAreaSelect;
